import { useQuery } from 'query';
import { type ApiClientResponseError, type NodeApiError } from 'common/services';
import { getTodos } from '../services';
import { Todo } from '../types';
import { getTodosQueryKey } from './';

export const useTodosQuery = (userId: string) =>
  useQuery<Todo[], ApiClientResponseError<NodeApiError>>(
    getTodosQueryKey(userId),
    async () => {
      const response = await getTodos();
      return response.data.map((todoDataObject) => new Todo(todoDataObject));
    },
    {
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
      refetchInterval: 5 * 60 * 1000, // 5 Minutes
      refetchOnMount: 'always',
    },
  );
